import { Pipe, PipeTransform } from '@angular/core';
import { Entity } from './classes/entity.class';
import { PlanningHirePeople } from './classes/planninghirepeople.class';
import { EntitiesService } from './services/entities/entities.service';

@Pipe({
    name: 'PlanningEntitiesToString',
    standalone: false,
})
export class PlanningEntitiesToStringPipe implements PipeTransform {
    constructor(private entitiesService: EntitiesService) {}

    transform(value: PlanningHirePeople[], eMap: Map<number, Entity>): string {
        if (value) {
            return value
                .map(v => {
                    const nr = v.count ? `(${v.count} st)` : '';
                    return `${eMap.get(v.entity_id).name} ${nr}`;
                })
                .join(', ');
        }
        return null;
    }
}
